import React, { useState, useEffect, useRef } from 'react';
import Button from '../../button/button.jsx';
import Select from '../../select/select.jsx';
import './printFormat.scss';
import adultsDiploma from './Diplomas/adultsDIplomaPDF.jsx';
import childrenDiploma from './Diplomas/childrenDiplomaPDF.jsx';
import EnrollmentProofPDF from './enrollmentProof.jsx';
import CompletionProofPDF from './completionProof.jsx';
import PrintSVG from '../../icons/print.jsx';
import Modal from '../../modal/modal.jsx';
import InputAutoComplete from '../../autocomplete/autocomplete.jsx';
import Axios from 'axios'
import { GetLevelList, GetPrincipalList, GetStudentListBySubsidiary } from '../../../utils/Apis/apis.jsx';
import { GetAllTeacherClassesBySubsidiaryNoEliminatedNoDaysOff, GetStudentProgressByStudent, GetTeacherClassById } from '../../../utils/Apis/receptionApis.jsx';

const PrintFormat = ({ onClose, usr, listSubsidiary }) => {
    const userInfo = usr
    //states
    const [selectedGroup, setSelectedGroup] = useState({ id: '' });
    const [selectedStudent, setSelectedStudent] = useState({ student_id: '' });
    const [selectedPrincipal, setSelectedPrincipal] = useState({ id: '' });
    const [manyPrints, setManyPrints] = useState('');
    const [selectedDocType, setSelectedDocType] = useState('');
    const [selectedDocument, setSelectedDocument] = useState('');
    const [selectedLevel, setSelectedLevel] = useState({ id: '' });
    const [arrayTeacherClasses, setArrayTeacherClasses] = useState([])
    const [arrayPrincipalList, setArrayPrincipalList] = useState([])
    const [LevelsAdults, setLevelsAdult] = useState([])
    const [LevelsChildren, setLevelsChildren] = useState([])
    const [levelOptions, setLevelOptions] = useState([])
    ////
    const [LevelAdultOG, setLevelAdultOG] = useState([]);
    const [LevelChildrenOG, setLevelChildrenOG] = useState([])
    //Booleant to check if student have two doc type options (Adult,Children)
    const [bothDocTypeOptions, setBothDocTypeOptions] = useState(true)

    const [selectedAutocompleted, setSelectedAutocompleted] = useState(null)

    const [subsidiary, setSubsidiary] = useState(userInfo ? userInfo.fk_subsidiary : '')

    //lISTS
    const [studentListState, setStudentListState] = useState([])
    const [arrayStudents, setArrayStudents] = useState([])
    const studentListCache = useRef({})
    const classListCache = useRef({})
    const principalAndLevelCache = useRef({
        data: null,
        timestamp: null
    });

    const [groupListState, setGroupListState] = useState([])
    const [arrayGroup, setArrayGroup] = useState([])
    const [principalList, setPrincipalList] = useState([])
    const subsidiaryList = listSubsidiary
    ///
    const [studentArrayProgress, setStudentArrayProgress] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const key = String(subsidiary);

            // ✅ Si ya hay caché, usarlo
            if (studentListCache.current[key]) {
                setStudentListState(studentListCache.current[key].data);
                setArrayStudents(studentListCache.current[key].rawData);
                return;
            }

            // ❌ No hay caché, pedir a la API
            try {
                const GetStudentList = await GetStudentListBySubsidiary(subsidiary, 1);
                if (GetStudentList.status === 200) {
                    const studentList = GetStudentList.result;
                    const formatStudentList = studentList.map(student => ({
                        value: student.student.id,
                        label: `${student.student.name} ${student.student.middle_name} ${student.student.last_name}`,
                    }));

                    // 🧠 Guardar en el caché
                    studentListCache.current[key] = {
                        data: formatStudentList,
                        rawData: studentList
                    };

                    setStudentListState(formatStudentList);
                    setArrayStudents(studentList);
                }
            } catch (error) {
                console.error("❌ Error al obtener lista de estudiantes:", error);
            }
        };

        if (subsidiary) {
            fetchData();
        }
    }, [subsidiary]);

    useEffect(() => {
        const fetchData = async () => {
            const key = String(subsidiary);

            // ✅ Si ya hay caché, usarlo
            if (classListCache.current[key]) {
                setStudentListState(classListCache.current[key].data);
                setArrayStudents(classListCache.current[key].rawData);
                console.log('✅ Usando caché');
                return;
            }

            // ❌ No hay caché, pedir a la API
            try {
                const GetClassList = await GetAllTeacherClassesBySubsidiaryNoEliminatedNoDaysOff(subsidiary);
                if (GetClassList.status === 200) {
                    const classList = GetClassList.teacherClasses;
                    const formatClassList = classList.map(c => ({
                        value: c.id,
                        label: `${c.teacher.name || 'Maestro no asignado'} / ${c.full_dayclass} / ${c.level.name} `,
                    }));

                    // 🧠 Guardar en el caché
                    classListCache.current[key] = {
                        data: formatClassList,
                        rawData: classList
                    };

                    setGroupListState(formatClassList);
                    setArrayGroup(classList);
                }
            } catch (error) {
                console.error("❌ Error al obtener lista de estudiantes:", error);
            }
        };

        if (subsidiary) {
            fetchData();
        }
    }, [subsidiary]);

    useEffect(() => {
        const fetchData = async () => {
            const now = new Date();
            const lastFetch = principalAndLevelCache.current.timestamp;

            // Si hay datos en caché y fue consultado hoy, úsalo
            if (
                principalAndLevelCache.current.data &&
                lastFetch &&
                now.toDateString() === new Date(lastFetch).toDateString()
            ) {
                const { principals, levels } = principalAndLevelCache.current.data;
                setPrincipalList(principals.formatted);
                setArrayPrincipalList(principals.raw);

                setLevelOptions(levels.raw);
                setLevelsAdult(levels.adults);
                setLevelAdultOG(levels.adults);
                setLevelsChildren(levels.kids);
                setLevelChildrenOG(levels.kids);
                return;
            }

            try {
                const [principalsResponse, levelResponse] = await Promise.all([
                    GetPrincipalList(),
                    GetLevelList()
                ]);

                if (principalsResponse.auth === false || levelResponse.auth === false) {
                    window.location.reload();
                    return;
                }

                // PRINCIPALES
                const rawPrincipals = principalsResponse.result;
                const formattedPrincipals = rawPrincipals.map(principal => ({
                    value: principal.id,
                    label: principal.name,
                    signature: principal.signature
                }));
                setArrayPrincipalList(rawPrincipals);
                setPrincipalList(formattedPrincipals);

                // NIVELES
                const rawLevels = levelResponse.result;
                const adults = rawLevels.adults.map(l => ({ value: l.id, label: l.name }));
                const kids = rawLevels.kids.map(l => ({ value: l.id, label: l.name }));

                setLevelOptions(rawLevels);
                setLevelsAdult(adults);
                setLevelAdultOG(adults);
                setLevelsChildren(kids);
                setLevelChildrenOG(kids);

                // Guardar en caché con timestamp
                principalAndLevelCache.current = {
                    data: {
                        principals: {
                            raw: rawPrincipals,
                            formatted: formattedPrincipals
                        },
                        levels: {
                            raw: rawLevels,
                            adults,
                            kids
                        }
                    },
                    timestamp: now
                };

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);




    const GetTeacherClassProgressByClass = async (id) => {
        const res = await Axios.post(process.env.REACT_APP_API_URL + "teacherClassProgressByClass/",
            {
                group_id: id
            }
            , {
                headers: {
                    "x-access-token": localStorage.getItem("token"),
                },
            })
        return res.data
    }


    //objects to fill selects inputs
    const document = [
        { value: 'ConstanciaEstudios', label: 'Constancia de estudios' },
        { value: 'ConstanciaFin', label: 'Constancia fin de estudios' },
        { value: 'diploma', label: 'Diploma' },
    ];

    //objects to fill selects inputs
    const docType = [
        { value: 'adults', label: 'Adultos' },
        { value: 'children', label: 'Niños' },
    ];

    const prints = [
        { value: 'individual', label: 'Individual' },
        { value: 'grupal', label: 'Grupal' },
    ];








    const processLessons = (lessonsCompleted, LevelAdultOG, LevelChildrenOG) => {
        let ThereIsAdultLesson = 0;
        let ThereIsChildrenLesson = 0;
        let AdultsLesson = [];
        let ChildrenLesson = [];

        lessonsCompleted.forEach(element => {
            if (element.type_id === 1) {
                ThereIsAdultLesson++;
                AdultsLesson.push(element);
            } else if (element.type_id === 2) {
                ThereIsChildrenLesson++;
                ChildrenLesson.push(element);
            }
        });
        if (ThereIsAdultLesson !== 0 && ThereIsChildrenLesson !== 0) {
            setBothDocTypeOptions(true);
            setSelectedDocType('');
        } else {
            // ✅ Ambos en cero → false
            if (ThereIsAdultLesson === 0 && ThereIsChildrenLesson === 0) {
                setBothDocTypeOptions(false);
                setSelectedDocType('');
            } else {
                // ✅ Hay al menos uno → true
                if (ThereIsAdultLesson !== 0) {
                    setBothDocTypeOptions(false);
                    setSelectedDocType('adults');
                }
                if (ThereIsChildrenLesson !== 0) {
                    setBothDocTypeOptions(false);
                    setSelectedDocType('children');
                }
            }
        }


        if (ThereIsAdultLesson !== 0) {
            const uniqueLevels = Array.from(new Set(LevelAdultOG.map(level => level.value)))
                .map(value => LevelAdultOG.find(level => level.value === value));
            const completedLevels = uniqueLevels.filter(level =>
                AdultsLesson.some(lesson => lesson.lesson_id === level.value)
            ).map(level => {
                // Agregar la propiedad completion_date
                const lesson = AdultsLesson.find(lesson => lesson.lesson_id === level.value);
                return {
                    ...level,
                    completion_date: lesson ? lesson.completion_date : null
                };
            });
            setLevelsAdult(completedLevels);
        }

        if (ThereIsChildrenLesson !== 0) {
            const uniqueLevels = Array.from(new Set(LevelChildrenOG.map(level => level.value)))
                .map(value => LevelChildrenOG.find(level => level.value === value));
            const completedLevels = uniqueLevels.filter(level =>
                ChildrenLesson.some(lesson => lesson.lesson_id === level.value)
            ).map(level => {
                // Agregar la propiedad completion_date
                const lesson = ChildrenLesson.find(lesson => lesson.lesson_id === level.value);
                return {
                    ...level,
                    completion_date: lesson ? lesson.completion_date : null
                };
            });
            setLevelsChildren(completedLevels);
        }
    };

    // function to handle when the principal change
    const handlePrincipalChange = (selectedOption) => {
        const principal = arrayPrincipalList.find(principal => principal.id === parseInt(selectedOption));
        setSelectedPrincipal(principal);
    };

    // function to handle when the document change
    const handleDocumentChange = (selectedOption) => {
        let selectedOpt = selectedOption;
        if ('ConstanciaEstudios') {
            setManyPrints('individual')
        }
        setSelectedDocument(selectedOpt);
        setSelectedLevel({ id: '' })
        setSelectedDocType('')
        setSelectedStudent({ student_id: '' })
        setSelectedGroup({ id: '' })
        setSelectedAutocompleted(null)
    };
    // function to handle when the document change
    const handleDocTypeChange = (selectedOption) => {
        let selectedOpt = selectedOption;
        setSelectedDocType(selectedOpt);
        setSelectedLevel({ id: '' })

    };

    const handleLevelChange = async (selectedOption) => {
        const levelId = Number(selectedOption);
        let selectedLevel;
        let matchingLevel;

        if (selectedDocType === 'adults') {
            selectedLevel = levelOptions.adults.find(level => level.id === levelId);
            matchingLevel = LevelsAdults.find(level => level.value === levelId);
        } else if (selectedDocType === 'children') {
            selectedLevel = levelOptions.kids.find(level => level.id === levelId);
            matchingLevel = LevelsChildren.find(level => level.value === levelId);
        }

        if (matchingLevel) {
            selectedLevel = {
                ...selectedLevel,
                completion_date: matchingLevel.completion_date
            };
        }

        if (selectedLevel) {
            const isAdult = selectedDocType === 'adults';
            const currentLevelId = selectedLevel.id;
            const typeIdToMatch = isAdult ? 1 : 2;

            let objectTeacher = selectedStudent?.teacher || {
                id: "",
                name: "",
                email: "",
                phoneNumber: "",
                signature: ""
            };

            if (selectedDocument === 'diploma' && manyPrints === 'individual') {

                const progressSelected = studentArrayProgress.find(
                    (v) => parseInt(v.lesson_id) === parseInt(currentLevelId)
                );
                const classIdToSearch = progressSelected?.class_id;

                if (classIdToSearch) {
                    try {
                        const res = await GetTeacherClassById(classIdToSearch);
                        if (res.status === 200) {
                            objectTeacher = res.teacherClasses[0]?.teacher || objectTeacher;
                        }
                    } catch (error) {
                        console.error("Error fetching teacher info:", error);
                    }
                }

            }
            // Ordenar progreso por fecha de finalización
            const sortedProgress = [...studentArrayProgress].sort(
                (a, b) => new Date(a.completion_date) - new Date(b.completion_date)
            );

            // Detectar si el nivel seleccionado fue el primero cursado cronológicamente
            const firstEverProgress = sortedProgress[0];
            const isSelectedTheFirstEverLesson = firstEverProgress?.lesson_id === currentLevelId;

            // Buscar el progreso anterior del mismo tipo
            const levelsOfSameType = studentArrayProgress
                .filter(e => e.type_id === typeIdToMatch && e.lesson_id < currentLevelId)
                .sort((a, b) => b.lesson_id - a.lesson_id);

            const previousLevelProgress = levelsOfSameType[0]; // Nivel anterior más cercano

            let date_start = selectedStudent.student_inscription_date;

            if (isSelectedTheFirstEverLesson) {
                //"🚸 Nivel seleccionado es el primero cursado. Usando inscripción."
                date_start = selectedStudent.student_inscription_date;
            } else if (previousLevelProgress) {
                const date = new Date(previousLevelProgress.completion_date);
                const getNextMonday = (d) => {
                    const day = d.getDay();
                    const diff = (8 - day) % 7 || 7;
                    const monday = new Date(d);
                    monday.setDate(d.getDate() + diff);
                    return monday.toISOString();
                };
                date_start = getNextMonday(date);
                //"✅ Fecha calculada desde nivel anterior del mismo tipo:", previousLevelProgress
            } else {
                // No hay progreso del mismo tipo, buscar el último progreso general DIFERENTE al nivel actual
                const lastCompleted = [...sortedProgress]
                    .reverse()
                    .find(e => e.lesson_id !== currentLevelId);

                if (lastCompleted) {
                    const date = new Date(lastCompleted.completion_date);
                    const getNextMonday = (d) => {
                        const day = d.getDay();
                        const diff = (8 - day) % 7 || 7;
                        const monday = new Date(d);
                        monday.setDate(d.getDate() + diff);
                        return monday.toISOString();
                    };
                    date_start = getNextMonday(date);
                    //"⚠️ No hay progreso del mismo tipo. Usando último progreso general DIFERENTE:
                }
            }

            setSelectedStudent(prev => ({
                ...prev,
                date: {
                    ...prev.date,
                    start: date_start,
                },
                teacher: objectTeacher
            }));

            setSelectedLevel(selectedLevel);
        } else {
            console.warn(`⚠️ Nivel con id ${selectedOption} no encontrado para tipo ${selectedDocType}`);
            setSelectedLevel(null);
        }
    };


    // function to handle when the prints number change
    const handleManyPrintsChange = (selectedOption) => {
        setSelectedGroup({ id: '' });
        setSelectedStudent({ student_id: '' });
        setManyPrints(selectedOption);
        setSelectedLevel({ id: '' })
        setSelectedDocType('')
        setSelectedAutocompleted(null)
    };

    //function to call the correct document and pass the properties
    const generatePDF = async () => {
        let pdfDoc;
        if (selectedDocument === 'diploma') {
            if (selectedDocType === 'adults' && selectedPrincipal) {
                if (selectedStudent.student_id !== '') {
                    pdfDoc = await adultsDiploma(selectedStudent, selectedPrincipal, selectedLevel);
                } else {
                    if (selectedGroup.id !== '') {
                        pdfDoc = await adultsDiploma(selectedGroup, selectedPrincipal, selectedLevel);

                    }
                }
            } else if (selectedDocType === 'children' && selectedPrincipal) {
                if (selectedStudent.student_id !== '') {
                    pdfDoc = await childrenDiploma(selectedStudent, selectedPrincipal, selectedLevel);
                } else {
                    if (selectedGroup.id !== '') {
                        pdfDoc = await childrenDiploma(selectedGroup, selectedPrincipal, selectedLevel);

                    }
                }
            }
        } else {
            if (selectedDocument === 'ConstanciaEstudios' && selectedPrincipal) {
                if (selectedStudent) {
                    pdfDoc = await EnrollmentProofPDF(selectedStudent, selectedPrincipal);
                } else if (selectedGroup) {
                    alert('La constancia de estudios solo se puede seleccionar para un estudiante');
                }
            } else if (selectedDocument === 'ConstanciaFin' && selectedPrincipal) {
                if (selectedGroup.id !== '') {
                    pdfDoc = await CompletionProofPDF(selectedGroup, selectedPrincipal, selectedLevel, selectedDocType);
                } else if (selectedStudent.student_id !== '') {
                    pdfDoc = await CompletionProofPDF(selectedStudent, selectedPrincipal, selectedLevel, selectedDocType);
                }
            }
        }
        if (pdfDoc) {
            pdfDoc.autoPrint();
            window.open(pdfDoc.output('bloburl'), '_blank');
        }
    };


    const getIsDisabled = () => {
        if (manyPrints === 'individual') {
            return selectedStudent.student_id === '' || bothDocTypeOptions === false;
        }
        return selectedGroup.id === '' || bothDocTypeOptions === false;
    };


    const isPrintDisabled = () => {
        // Condiciones para documentos específicos
        if (selectedDocument === '') return true;
        if (selectedDocument === 'ConstanciaEstudios') {
            return selectedPrincipal.id === '' || selectedStudent.student_id === '' || selectedStudent.is_register_in_any_class !== 1;
        }
        if (selectedDocument === 'ConstanciaFin') {
            return manyPrints === 'individual' ? selectedPrincipal.id === '' || selectedStudent.student_id === '' ||
                (selectedStudent.is_register_in_any_class !== 1 && selectedLevel.id === '') : selectedPrincipal.id === '' || selectedGroup.id === '' || selectedGroup.students.length === 0;
        }

        if (selectedDocument === 'diploma') {
            return manyPrints === 'individual'
                ? selectedStudent.student_id === '' || selectedPrincipal.id === '' || selectedDocType === '' || selectedLevel.id === ""
                : selectedGroup.id === '' || selectedPrincipal.id === '' || selectedDocType === '' || selectedLevel.id === "";
        }

        // Condiciones generales para otros documentos
        if (selectedDocType === '') return true;
        if (selectedLevel.id === '') return true;

        // Para casos de impresiones individuales o grupales
        if (manyPrints === 'individual') {
            return selectedStudent.student_id === '';
        } else if (manyPrints === 'grupal') {
            return selectedGroup.id === '';
        }

        // Habilitado si todas las condiciones se cumplen
        return false;
    };
    function formatSchedule(dayString, timeStart, timeEnd) {
        const daysOrder = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
        const dayList = dayString.split(', ').map(day => day.trim());

        // Obtener índices ordenados según el orden de la semana
        const dayIndices = dayList.map(day => daysOrder.indexOf(day)).sort((a, b) => a - b);

        // Verificar si son consecutivos
        const isConsecutive = dayIndices.every((val, i, arr) => i === 0 || val === arr[i - 1] + 1);

        let dayFormatted = '';

        if (isConsecutive && dayList.length > 1) {
            dayFormatted = `${dayList[0]} a ${dayList[dayList.length - 1]}`;
        } else {
            dayFormatted = dayList.join(', ');
        }

        return `${dayFormatted}, de ${timeStart} a ${timeEnd}`;
    }

    // function to handle when the student change
    const handleStudentChange = async (selectedOption) => {
        setStudentArrayProgress([])
        if (selectedOption !== null) {
            setSelectedAutocompleted(selectedOption);
            let selectedStudentOnChange = null;
            // itarate all the groups to find the student and restructure the object
            selectedStudentOnChange = arrayStudents.find(s => s.student.id === parseInt(selectedOption.value))
            const subsidiaryInfo = subsidiaryList.find(sub => parseInt(sub.value) === parseInt(subsidiary));
            if (selectedStudentOnChange) {
                let scheduleFormatted = ''
                if (selectedStudentOnChange.class_info?.id) {
                    scheduleFormatted = formatSchedule(selectedStudentOnChange.class_info.day, selectedStudentOnChange.class_info.time_start, selectedStudentOnChange.class_info.time_end)
                }
                const studentObject = {
                    student_id: selectedStudentOnChange.student.id,
                    student_name: selectedStudentOnChange.student.name,
                    student_middle_name: selectedStudentOnChange.student.middle_name,
                    student_last_name: selectedStudentOnChange.student.last_name,
                    student_inscription_date: selectedStudentOnChange.student.inscription_date,
                    is_register_in_any_class: selectedStudentOnChange.class_info.is_register_in_any_class,
                    subsidiary: {
                        name: subsidiaryInfo?.label || '',
                        address: subsidiaryInfo?.info?.address || '',
                        phone: subsidiaryInfo?.info?.phone || ''
                    },
                    schedule: scheduleFormatted
                };


                if (selectedDocument === 'ConstanciaFin' || selectedDocument === 'diploma') {
                    setSelectedLevel({ id: '' })
                    const studentProgress = await GetStudentProgressByStudent(studentObject.student_id)
                    let arrayProgress = studentProgress.result;
                    setStudentArrayProgress(arrayProgress)
                    processLessons(arrayProgress, LevelAdultOG, LevelChildrenOG);
                    const actualClass = selectedStudentOnChange.class_info;
                    let objectTeacher = {
                        id: "",
                        name: "",
                        email: "",
                        phoneNumber: "",
                        signature: ""
                    }
                    if (actualClass?.id) {
                        const actualClassRes = await GetTeacherClassById(actualClass.id);
                        if (actualClassRes.status === 200) {
                            const array = actualClassRes.teacherClasses
                            objectTeacher = array[0].teacher
                        }
                    }
                    // Unifica niveles en un solo arreglo
                    const allLevels = [...levelOptions.adults, ...levelOptions.kids];
                    // Encuentra el nivel que coincide por nombre
                    const matchedLevel = allLevels.find(
                        (level) => level.name === actualClass.level.name
                    );
                    let date_start = ''
                    if (arrayProgress.length === 0) {
                        date_start = selectedStudentOnChange.student.inscription_date
                    } else {
                        if (selectedLevel.id === '') {
                            // Ordena progreso por fecha descendente (más reciente primero)
                            const sortedProgress = [...arrayProgress].sort(
                                (a, b) => new Date(b.completion_date) - new Date(a.completion_date)
                            );
                            const mostRecentLesson = sortedProgress[0]; // la más reciente, sin importar lesson_id

                            if (mostRecentLesson) {
                                const date = new Date(mostRecentLesson.completion_date);
                                const nextMonday = 8 - date.getDay();
                                const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + nextMonday);
                                date_start = newDate.toISOString();
                            } else {
                                // Ningún progreso → inscripción
                                date_start = selectedStudentOnChange.student.inscription_date;
                            }
                        }
                    }
                    // Si se encuentra, agrega los datos deseados
                    const propertiesToAdd = {
                        level: matchedLevel
                            ? {
                                id: matchedLevel.id,
                                name: matchedLevel.name,
                                hours: matchedLevel.hours,
                            }
                            : null,
                        date: {
                            start: date_start, // Usa el campo correcto
                        },
                        teacher: objectTeacher
                    };
                    Object.assign(studentObject, propertiesToAdd);
                }
                setSelectedStudent(studentObject)


            }

        }
    };

    
    // function to handle when the gruop change
    const handleGroupChange = async (selectedOption) => { // Verifica el objeto completo
        if (selectedOption !== null) {
            setSelectedAutocompleted(selectedOption);
            let selectedClassChange = null;
            // itarate all the groups to find the student and restructure the object
            selectedClassChange = arrayGroup.find(g => parseInt(g.id) === parseInt(selectedOption.value))
            const groupIdValue = parseInt(selectedOption.value);
            const classProgress = await GetTeacherClassProgressByClass(groupIdValue)
            const arrayProgress = classProgress.result
            processLessons(arrayProgress, LevelAdultOG, LevelChildrenOG);
            setSelectedLevel({ id: '' })
            setSelectedGroup(selectedClassChange); // Actualiza el estado con el grupo encontrado
        }
    };
    const getFullName = (alumno) => {
        return `${alumno.label}`;
    };

    const handleSubsidiaryChange = (event) => {
        setSubsidiary(event.target.value)
        setSelectedStudent({ student_id: '' })
        setSelectedGroup({ id: '' })
        setSelectedAutocompleted(null)
    }
    return (
        <>
            <Modal isOpen={true} onClose={onClose} overlayClick={false}>
                <div className='main-color print-format'>
                    <section className='print-header'>
                        <h1>Imprimir documento</h1>
                    </section>
                    <section className='print-body'>
                        <Select
                            options={subsidiaryList}
                            placeholder="Plantel"
                            className={'main-color'}
                            value={subsidiary}
                            onChange={(e) => handleSubsidiaryChange(e)}
                        />
                        <Select
                            classN='main-color'
                            options={document}
                            placeholder={'Selecciona tipo de documento'}
                            onChange={(e) => handleDocumentChange(e.target.value)}
                            value={selectedDocument}
                        />
                        <Select
                            classN='main-color'
                            options={prints}
                            placeholder={'Selecciona número de impresiones'}
                            onChange={(e) => handleManyPrintsChange(e.target.value)}
                            value={manyPrints}
                            disabled={(selectedDocument === 'ConstanciaEstudios' || selectedDocument === '') && true}
                        />
                        <Select
                            classN='main-color'
                            options={principalList}
                            placeholder={'Selecciona un director'}
                            onChange={(e) => handlePrincipalChange(e.target.value)}
                            value={selectedPrincipal.id}
                            disabled={selectedDocument === '' && true}
                        />
                        <InputAutoComplete
                            options={manyPrints === 'individual' ? studentListState : groupListState}
                            className={'main-color autoCompleteSelect'}
                            onChange={manyPrints === 'individual' ? (event, newValue) => handleStudentChange(newValue) : (event, newValue) => handleGroupChange(newValue)}
                            isOptionEqualToValue={(option, value) => option.value === value.value} // Comparación basada en el 'id'
                            disabled={selectedDocument === '' && true}
                            getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                            value={selectedAutocompleted}
                            placeholder={manyPrints === 'individual' ? "Buscar Alumno..." : 'Buscar Grupo...'}

                        />
                        {
                            selectedDocument !== '' && selectedDocument !== 'ConstanciaEstudios' &&
                            <>
                                <Select
                                    classN='main-color'
                                    options={docType}
                                    placeholder={'selecciona tipo'}
                                    onChange={(e) => handleDocTypeChange(e.target.value)}
                                    value={selectedDocType}
                                    disabled={getIsDisabled()}
                                />
                                <Select
                                    classN='main-color'
                                    options={selectedDocType === 'adults' ? LevelsAdults : LevelsChildren}
                                    placeholder={selectedDocument === 'diploma' ? 'selecciona nivel' : 'Imprimir nivel actual'}
                                    onChange={(e) => handleLevelChange(e.target.value)}
                                    value={selectedLevel.id}
                                    disabled={(selectedDocument === '' || selectedDocType === '') && true}
                                />
                            </>
                        }
                    </section>
                    <section className='print-footer'>
                        <Button onClick={() => generatePDF('print')} text="Imprimir" Icon={PrintSVG} disabled={isPrintDisabled()} />
                        <Button onClick={onClose} text='Cancelar'></Button>
                    </section>
                </div>
            </Modal>
        </>
    );
}

export default PrintFormat;
